export default ({store}) => {
  store.dispatch('validation/clearErrors');
};
